import { getAccountData } from './fetch';
import { nftCache } from './cache';

export const isNftCheck = async (issuerAccount, assetCode, network) => {
  if (!assetCode || !issuerAccount) {
    return false;
  }
  const accountData = nftCache[issuerAccount] || await getAccountData(issuerAccount, network);

  return !!accountData[`IPFS_NFT_1_${assetCode}`] || (!accountData[assetCode] && !!accountData['IPFS_NFT_1']);
}


// WEBPACK FOOTER //
// ./src/nft.js